import { REQUEST_NPZ, NPZ } from "../../const";
import axios from "axios";

export const fetchNpzData = (npz) => {
  return {
    type: REQUEST_NPZ,
    npz,
  };
};

export const fetchNpzsData = () => {
  return (dispatch) => {
    return axios
      .get(NPZ)
      .then((response) => {
        dispatch(fetchNpzData(response.data));
        //// // // // console.log("NPZ",response.data)
      })
      .catch((error) => {
        //// // // // console.log("err")
        throw error;
      });
  };
};
